<template>
  <div class="wrapper-x-40">
    <AdminStickyHeader>
      <template #title>
        {{ page ? $t('main.title_edit_element')+":" : $t('main.title_add_element')+":" }}
        {{ $t('admin.views.pages.title') }}
      </template>
      <template #actions>
        <Loading
          v-if="loadingSaveData"
          class="mb-2"
        />
        <div class="form-group flex flex-wrap items-center gap-3">
          <button
            @click="saveData"
            type="button"
            class="btn btn-small btn-green"
          >
            {{ $t('main.button_save') }}
          </button>
          <router-link
            class="btn btn-small btn-default"
            :to="{
              name: 'pages',
              query: $route.query
            }"
          >{{ $t('main.button_cancel') }}</router-link>
        </div>
      </template>
    </AdminStickyHeader>
    <div class="form">
      <BaseInput
        id="title"
        :label="$t('main.label_name')"
        v-model="form.title"
        :required="true"
        :errors="errorsFor('title')"
      />

      <div class="form-group">
        <label
          for="content"
          class="font-bold"
        >{{ $t('main.label_content') }} *: </label>
        <div>
          <ckeditor
            id="content"
            :editor="editor"
            :config="editorConfig"
            v-model="form.content"
          ></ckeditor>
        </div>
        <ValidationErrors :errors="errorsFor('content')" />
      </div>
      <div class="form-group">
        <label class="font-bold">{{ $t('main.label_status') }}: </label>
        <div>
          <button
            class="rounded flex items-center focus:outline-none gap-2"
            type="button"
            @click="form.status = form.status == 1 ? 0 : 1"
          >
            <span class="check"><i
                v-if="form.status == 1"
                class="fas fa-check text-red-500"
              ></i></span>
            <span class="text-sm">{{$t('main.published')}}</span>
          </button>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import AdminStickyHeader from "../../../components/Admin/StickyHeader.vue";
import validationErrors from "../../../mixins/validationErrors";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
export default {
  name: "Form",
  components: { AdminStickyHeader },
  mixins: [validationErrors],
  props: {
    page: {
      type: Object,
    },
  },
  data() {
    return {
      editor: ClassicEditor,
      editorConfig: {
        language: "ru",
        simpleUpload: {
          uploadUrl: "/api/ckeditor/upload-image",
          withCredentials: false,
        },
      },
      loadingSaveData: false,
      form: {
        title: this.page ? this.page.title : "",
        content: this.page ? this.page.content : "",
        status: this.page ? parseInt(this.page.status) : 1,
      },
    };
  },
  mounted() {
    if (!this.licensed) this.$router.push({ name: "no_license" });
  },
  computed: {
    licensed() {
      return this.$store.getters["licensed"];
    },
  },
  methods: {
    async saveData() {
      this.errors = null;
      this.loadingSaveData = true;
      try {
        let formDataPost = new FormData();

        if (this.page) formDataPost.append("_method", "PATCH");

        if (this.form.title !== null) {
          formDataPost.append("title", this.form.title);
        }

        if (this.form.content !== null) {
          formDataPost.append("content", this.form.content);
        }

        formDataPost.append("status", parseInt(this.form.status));

        let url = `/api/admin/pages`;
        if (this.page) url = `/api/admin/pages/${this.page.page_id}`;

        const res = (
          await axios.post(url, formDataPost, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
        ).data;
        const pageId = res?.data?.page?.page_id;
        if (!pageId) {
          throw new Error("Некорректный ответ сервера");
        }

        if (!this.page) {
          await this.$router
            .replace({
              name: "edit_page",
              params: { page_id: pageId },
              query: this.$route.query,
            })
            .catch((e) => {});
        }
      } catch (error) {
        this.errors = error?.response?.data?.errors || null;
        this.status = error?.response?.status || null;
        const notification = {
          type: "error",
          message:
            error?.response?.data?.message ||
            error?.message ||
            "Ошибка при сохранении",
        };
        this.$store.dispatch("notification/add", notification, {
          root: true,
        });
      }
      this.loadingSaveData = false;
    },
  },
};
</script>
